import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { useConfirmKYCPedagogicalStepMutation } from 'api/tunnelSteps';
import { fundTypes } from 'utils/constants';
import { isStatusOk } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import TunnelBox from '../common/TunnelBox';
import TunnelStep from '../common/TunnelStep';
import { SubmitButton } from 'components';
import { Typography } from '@mui/material';

const stepTitleStyle = { fontSize: 'inherit', display: 'block' };

const KYCPedagogicStep = ({ handleNextStep, userStep }) => {
    const subscription = useSelector(userSelectors.getTunnelSubscription);
    const fundName = useMemo(() => subscription?.investmentFund?.name || '-', [subscription]);
    const fundType = useMemo(() => subscription?.investmentFund?.type || '-', [subscription]);
    const isResubmit = useMemo(() => userStep?.successfulAttemptsNumber > 0, [userStep]);
    const hasStatusOk = useMemo(() => isStatusOk(userStep), [userStep]);
    const isSLP = subscription?.investmentFund?.type === fundTypes.SLP;
    const isFCPR = subscription?.investmentFund?.type === fundTypes.FCPR;

    const [confirmKYCPedagogicalStep, { isLoading: submitLoader, isSuccess, reset }] =
        useConfirmKYCPedagogicalStepMutation();

    useEffect(() => {
        if (isSuccess) {
            reset();
            handleNextStep(true);
        }
    }, [isSuccess, handleNextStep, reset]);

    return (
        <TunnelStep
            title={
                <React.Fragment>
                    <Typography component="span" sx={stepTitleStyle}>
                        {texts.KYC_PEDAGOGIC_STEP_1}
                    </Typography>
                    <Typography component="span" sx={stepTitleStyle}>
                        {texts.KYC_PEDAGOGIC_STEP_2}
                    </Typography>
                </React.Fragment>
            }
            maxWidth={950}
        >
            <TunnelBox>
                {isSLP || isFCPR ? (
                    <Typography>{texts.KYC_PEDAGOGIC_STEP_SLP}</Typography>
                ) : (
                    <React.Fragment>
                        <Typography gutterBottom>{texts.KYC_PEDAGOGIC_STEP_PARAGRAPH_1}</Typography>
                        <br></br>
                        <Typography gutterBottom>
                            {texts.KYC_PEDAGOGIC_STEP_PARAGRAPH_2(fundType, fundName)}
                        </Typography>
                        <br></br>
                        <Typography gutterBottom>{texts.KYC_PEDAGOGIC_STEP_PARAGRAPH_3}</Typography>
                    </React.Fragment>
                )}
            </TunnelBox>
            <SubmitButton
                onClick={isResubmit && hasStatusOk ? handleNextStep : confirmKYCPedagogicalStep}
                loading={submitLoader}
                disabled={submitLoader}
                text={texts.SUIVANT}
            />
        </TunnelStep>
    );
};

export default KYCPedagogicStep;
